<template>
    <v-dialog v-model="showDialog_Roles" width="650" persistent>
        <v-card>
            <v-card-title class="blue-grey pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px;" class="b-fa b-fa-key"></i>&nbsp;&nbsp;Select/Modify Roles(s) on Flight
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <!-- >>> Instructor ---------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">Instructor:</p>
                            <v-select
                                v-model="instructor"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Instructor:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> Checker  ---------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">Checker:</p>
                            <v-select
                                v-model="checker"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Checker:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> Trainee  ------------------------------ -->
                            <p class="" style="font-size:13px; font-weight: 500;">Trainee:</p>
                            <v-select
                                v-model="trainee"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Trainee:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> Safety Pilot  ------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">Safety Pilot:</p>
                            <v-select
                                v-model="safety"
                                :items="get_flights_CrewDetails_Reduced_Filtered"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Safety Pilot:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> Ferry  -------------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">Ferry:</p>
                            <v-select
                                v-model="ferry"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Ferry:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> ACM  ---------------------------------- -->
                            <p class="" style="font-size:13px; font-weight: 500;">ACM:</p>
                            <v-select
                                v-model="acm"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="ACM:"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onCancel_Roles">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Roles_DoRolesCall">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';


    export default {
        name : 'Dialog_Roles',

        /* >>> *************************************************************** / /* Props */
        props : {
            value : [ Boolean, Object ], // showDialog_Roles
        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * watch::get_flights_CrewDetails_Reduced
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_Reduced'.
            * Note:
            *
            */
            get_flights_CrewDetails_Reduced(v) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_Roles.vue >>> mounted');
                this.get_flights_CrewDetails_Reduced_Filtered = [];

                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    // >>> Prefill - TakeOFf/Landing ------
                    if (member.position === 'CP' || member.position === 'FO') {
                        this.get_flights_CrewDetails_Reduced_Filtered.push(member);
                    }

                    // >>> Preset1 ------------------------
                    for (let i = 0; i < member.roles.length; i++) {
                        if (member.roles[i] === 'INSTRUCTOR') {
                            if (!this.instructor.includes(member.idResource)) {
                                this.instructor.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'CHECKER') {
                            if (!this.checker.includes(member.idResource)) {
                                this.checker.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'TRAINEE') {
                            if (!this.trainee.includes(member.idResource)) {
                                this.trainee.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'SAFETY') {
                            if (!this.safety.includes(member.idResource)) {
                                this.safety.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'FERRY') {
                            if (!this.ferry.includes(member.idResource)) {
                                this.ferry.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'ACM') {
                            if (!this.acm.includes(member.idResource)) {
                                this.acm.push(member.idResource);
                            }
                        }
                    }
                });

            }, // eo function get_flights_CrewDetails_SavedPayload()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_Reduced',
                'get_flights_CrewDetails_SavedPayload', // getting 'idFlightGroup'
                'get_flights_CrewDetails_Department',
            ]),


            /*******************************************************************
            * showDialog_Roles()
            *
            * Desc:
            * Note:
            *
            */
            showDialog_Roles: {

                /***************************************************************
                * get()
                *
                * Note:.
                *
                */
                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/DialogFunctions.vue >>> showDialog_Roles get');
                    // return always Boolean
                    return !!this.value;

                }, // eo showDialog_Roles get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/DialogFunctions.vue >>> showDialog_Roles set');
                    this.$emit('input', value);

                } // eo showDialog_Roles set()

            } // eo function showDialog_Roles()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                get_flights_CrewDetails_Reduced_Filtered: [],
                // >>> --------------------------
                instructor: [],
                checker: [],
                trainee: [],
                safety: [],
                ferry: [],
                acm: [],
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_crews_setDutyFlags',
                'actn_call_crews_setFlightRoles',
                'actn_call_getCrewDetailsFromFlight_Reduced'
            ]),


            /*******************************************************************
            * onSave_Roles_DoRolesCall()
            *
            * Desc: Do the 'Roles' Call(s).
            * Note: Via 'dutyflagsacallsarefinished' Emit.
            * Note: All 'DutyFlag' Call(s) are finished.
            *
            */
            onSave_Roles_DoRolesCall: function() {

                let me = this,
                    paramsFlightRoles = {
                        "idFlight": null,
                        "roles": null
                    },
                    roles = [],
                    memberWasSet = false,
                    idFlight = this.get_flights_CrewDetails_SavedPayload.idFlightGroup,
                    get_flights_CrewDetails_Reduced_Copy = [...this.get_flights_CrewDetails_Reduced];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_Roles.vue >>> onSave_Roles_DoRolesCall');
                // >>> ------------------------------------ 1. Roles
                get_flights_CrewDetails_Reduced_Copy.forEach(member => {
                    if (this.instructor.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'INSTRUCTOR'});
                        memberWasSet = true;
                    }

                    if (this.checker.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'CHECKER'});
                        memberWasSet = true;
                    }

                    if (this.trainee.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'TRAINEE'});
                        memberWasSet = true;
                    }

                    if (this.safety.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'SAFETY'});
                        memberWasSet = true;
                    }

                    if (this.ferry.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'FERRY'});
                        memberWasSet = true;
                    }

                    if (this.acm.includes(member.idResource)) {
                        roles.push({ 'idResource': member.idResource, 'role': 'ACM'});
                        memberWasSet = true;
                    }

                    if (memberWasSet === false) {
                        roles.push({ 'idResource': member.idResource, 'role': null});
                    }


                    memberWasSet = false; // reset
                });

                paramsFlightRoles = {
                    "idFlight": idFlight,
                    "roles": roles
                };
                this.actn_call_crews_setFlightRoles({ params: paramsFlightRoles });


                // >>> ------------------------------------ Close/Reset/Reload
                setTimeout(() => {
                    Vue.prototype.$vp_um();
                    this.showDialog_Roles = false;
                    this.actn_call_getCrewDetailsFromFlight_Reduced({ idFlight: this.get_flights_CrewDetails_SavedPayload.idFlightGroup });
                }, 700);

            }, // eo function onSave_Roles_DoRolesCall()


            /*******************************************************************
            * onCancel_Roles()
            *
            * Desc:
            * Note:
            *
            */
            onCancel_Roles: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_Roles.vue >>> onCancel_Roles');
                this.showDialog_Roles = false; // close

                this.instructor = []; // reset
                this.checker = [];
                this.trainee = [];
                this.safety = [];
                this.ferry = [];
                this.acm = [];


                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    // >>> Prefill - TakeOFf/Landing ------
                    if (member.position === 'CP' || member.position === 'FO') {
                        this.get_flights_CrewDetails_Reduced_Filtered.push(member);
                    }

                    // >>> Preset1 ------------------------
                    for (let i = 0; i < member.roles.length; i++) {
                        if (member.roles[i] === 'INSTRUCTOR') {
                            if (!this.instructor.includes(member.idResource)) {
                                this.instructor.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'CHECKER') {
                            if (!this.checker.includes(member.idResource)) {
                                this.checker.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'TRAINEE') {
                            if (!this.trainee.includes(member.idResource)) {
                                this.trainee.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'SAFETY') {
                            if (!this.safety.includes(member.idResource)) {
                                this.safety.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'FERRY') {
                            if (!this.ferry.includes(member.idResource)) {
                                this.ferry.push(member.idResource);
                            }
                        }
                        if (member.roles[i] === 'ACM') {
                            if (!this.acm.includes(member.idResource)) {
                                this.acm.push(member.idResource);
                            }
                        }
                    }
                });

            }, // eo function onCancel_Roles()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-top: 4px !important;
    }
</style>
